import { render, staticRenderFns } from "./df-page-page.vue?vue&type=template&id=647c00a2"
import script from "./df-page-page.ts?vue&type=script&lang=js&external"
export * from "./df-page-page.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports